import { createSlice } from '@reduxjs/toolkit';

const favouritesSlice = createSlice({
  name: 'favourites',
  initialState: { ids: [] },
  reducers: {
    setFavouriteIds(state, action) {
      state.ids = action.payload;
    },
    toggleFavourite(state, action) {
      const productId = action.payload;
      const index = state.ids.indexOf(productId);
      if (index >= 0) {
        state.ids.splice(index, 1);
      } else {
        state.ids.push(productId);
      }
    },
  },
});

export const { setFavouriteIds, toggleFavourite } = favouritesSlice.actions;
export const selectFavouriteIds = (state) => state.favourites.ids;
export const selectIsFavourite = (productId) => (state) =>
  state.favourites.ids.includes(productId);

export default favouritesSlice.reducer;
